<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
             :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="学生姓名" prop="studentName">
        <el-input v-model.trim="dataForm.studentName" placeholder="学生姓名"></el-input>
      </el-form-item>
      <el-form-item label=" 班级" prop="classId">
        <el-select v-model="dataForm.classId" placeholder="请选择" clearable style="width: 100%" :disabled="dataForm.id">
          <el-option v-for=" (classObj,index) in classList" :key="index" :value="classObj.id"
                     :label="superAdmin? `${classObj.schoolName}/${classObj.className}`:`${classObj.className}`"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="身份证号" prop="idCardNum">
        <el-input v-model="dataForm.idCardNum" placeholder="身份证号"></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="studentSex">
        <el-radio-group v-model="dataForm.studentSex">
          <el-radio :label="0">女</el-radio>
          <el-radio :label="1">男</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="学校" prop="schoolId" v-if="schoolVisible">
        <el-select v-model="dataForm.schoolId" placeholder="请选择学校" clearable>
          <el-option v-for="school in schoolList" :label="school.schoolName" :value="school.id"
                     :key="school.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { isIdCardNum } from '@/utils/validate'
export default {
  data () {
    return {
      visible: false,
      classList: [],
      schoolVisible: false,
      schoolList: [],
      superAdmin: 0,
      dataForm: {
        id: '',
        studentName: '',
        classId: '',
        className: '',
        idCardNum: '',
        studentSex: 0,
        schoolId: ''
      }
    }
  },
  computed: {
    dataRule () {
      const validateIdCardNum = (rule, value, callback) => {
        if (!isIdCardNum(value)) {
          return callback(new Error('身份证格式错误'))
        }
        callback()
      }
      return {
        studentName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        classId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        idCardNum: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: validateIdCardNum, trigger: 'blur' }
        ],
        studentSex: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        schoolId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.superAdmin = this.$store.state.user.superAdmin
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        this.resetValue()
        Promise.all([
          this.getClassList()
        ]).then(() => {
          if (this.dataForm.id) {
            this.getInfo()
          }
        })
      })
    },
    getClassList () {
      this.$http.get('/classmanage/classmanage/myClassList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.classList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/student/student/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {
      })
    },
    resetValue () {
      this.dataForm.schoolId = ''
      this.schoolVisible = false
    },
    // 获取学校的集合
    getSchoolList () {
      this.$http.get('/school/school/getSchoolList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.schoolList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.className = this.classList.filter((e) => { return e.id === this.dataForm.classId })[0].className
        this.$http[!this.dataForm.id ? 'post' : 'put'](`/student/student?schoolId=${this.dataForm.schoolId}`, this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            if (res.code === 10050) {
              this.schoolVisible = true
              this.getSchoolList()
            }
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
